import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { useUserNames } from "../../../hooks";

interface ServiceAreaFilters {
  page: number;
  limit: number;
  remote_utility_id: number;
  config_level: string;
  show_inactive?: boolean;
  search_data?: string;
  created_by?: string;
}

interface ServiceAreaFilterPanelProps {
  currentFilters: ServiceAreaFilters;
  onApplyFilters: (filters: Partial<ServiceAreaFilters>) => void;
  onResetFilters: () => void;
  entityType: string;
}

export const ServiceAreaFilterPanel: React.FC<ServiceAreaFilterPanelProps> = ({
  currentFilters,
  onApplyFilters,
  onResetFilters,
  entityType,
}) => {
  // const { data: userNames = [] } = useUserNames();

  const form = useForm({
    defaultValues: {
      show_inactive:
        typeof currentFilters.show_inactive === "boolean"
          ? currentFilters.show_inactive.toString()
          : "false",
      created_by: currentFilters.created_by || "all",
    },
  });

  useEffect(() => {
    form.setValue(
      "show_inactive",
      typeof currentFilters.show_inactive === "boolean"
        ? currentFilters.show_inactive.toString()
        : "true"
    );
    form.setValue("created_by", currentFilters.created_by || "all");
  }, [currentFilters]);

  const handleApplyFilters = (data: any) => {
    const filtersToApply: Partial<ServiceAreaFilters> = {};

    if (data.show_inactive === "true" || data.show_inactive === "false") {
      filtersToApply.show_inactive = data.show_inactive === "true";
    }

    if (data.created_by && data.created_by !== "all") {
      filtersToApply.created_by = data.created_by;
    }

    onApplyFilters(filtersToApply);
  };

  const handleResetFilters = () => {
    form.reset({ show_inactive: "true", created_by: "all" });
    onResetFilters();
  };

  // const userOptions = userNames.map((user: any) => ({
  //   label: user.name,
  //   value: user.name,
  // }));

  return (
    <form onSubmit={form.handleSubmit(handleApplyFilters)}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Status Filter */}
        <div className="space-y-2">
          <Label>Status</Label>
          <Controller
            name="show_inactive"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="true">Active</SelectItem>
                    <SelectItem value="false">Inactive</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        {/* Created By Filter */}
        {/* <div className="space-y-2">
          <Label>Created By</Label>
          <Controller
            name="created_by"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select user" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="all">All Users</SelectItem>
                    {userOptions.map((user) => (
                      <SelectItem key={user.value} value={user.value}>
                        {user.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div> */}

        {/* Action Buttons */}
        <div className="col-span-1 md:col-span-2 lg:col-span-3 flex justify-end gap-2 pt-4 border-t border-gray-200">
          <Button type="button" variant="outline" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          <Button type="submit">Apply Filters</Button>
        </div>
      </div>
    </form>
  );
};
